import { ChangeDetectionStrategy, Component, inject, input, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@recruitee/i18n';

import { IconComponent } from '../../../../../common/icon/icon.component';
import { FormFieldComponent } from '../../../../form-field/form-field.component';
import { InputComponent } from '../../../../input/input.component';
import { SEARCH_FEATURE } from '../types';
import { Select2SearchDirective } from './search.directive';

@Component({
  selector: 'rt-select2-search',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InputComponent,
    FormFieldComponent,
    IconComponent,
    TranslatePipe,
    ReactiveFormsModule,
    Select2SearchDirective,
  ],
  template: `
    <ng-template rt-select-search>
      <div class="search-container">
        <rt-form-field (click)="$event.preventDefault()" class="context-default">
          <rt-input
            [autoFocus]="true"
            [hasClearButton]="true"
            [placeholder]="placeholder() || ('rtu.common.search' | translate)"
            [formControl]="searchFeature.searchControl$.value"
            (reset)="searchFeature.searchControl$.value.reset()"
            variant="rounded"
          >
            <rt-icon prefix name="search" />
          </rt-input>
        </rt-form-field>
      </div>
    </ng-template>
  `,
  styleUrls: ['./search-default.component.less'],
  providers: [
    {
      provide: Select2SearchDirective,
      useFactory: () => inject(Select2DefaultSearchComponent).directive(),
    },
  ],
})
export class Select2DefaultSearchComponent {
  public directive = viewChild.required(Select2SearchDirective);

  public placeholder = input<string>();

  public searchFeature = inject(SEARCH_FEATURE);
}
